import assign from 'object-assign';
import { EventEmitter } from 'events';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';

const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'TRIPS_CHANGED';

let trips = [];

const TripsStore = assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  onGetTripsSuccess(payload) {
    trips = payload;
    this.emitChange();
  },

  getTrips() {
    return trips;
  },

});

TripsStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
  const action = payload.action;
  switch (action.type) {
    case ActionTypes.GET_TRIPS_SUCCESS:
      TripsStore.onGetTripsSuccess(action.trips);
      break;
    default:
      break;
  }
});

export default TripsStore;
